import React, { useState, useEffect, useRef } from "react";
import styles from "./IndustriesSection.module.css";

import {
  FaBank, // 🏦 Finance & Banking
  FaBuilding, // 🏬 Real Estate
  FaHeartbeat, // 🩺 Healthcare
  FaGraduationCap, // 🎓 Education
  FaShoppingCart, // 🛍️ Retail
  FaPlane, // ✈️ Travel
} from 'react-icons/fa';


import { CiBank } from "react-icons/ci";


const industries = [
  {
    icon: <CiBank />, // Replaces 🏦
    title: "Finance & Banking",
    points: [
      "Send instant transaction alerts",
      "Notify about account updates",
      "Promote loan & credit card deals",
    ],
  },
  {
    icon: <FaBuilding />, // Replaces 🏬
    title: "Real Estate",
    points: [
      "Schedule property visits",
      "Distribute property brochures",
      "Highlight upcoming property launches",
    ],
  },
  {
    icon: <FaHeartbeat />, // Replaces 🩺
    title: "Healthcare",
    points: [
      "Simplify patient onboarding",
      "Book and confirm appointments",
      "Update on health report status",
    ],
  },
  {
    icon: <FaGraduationCap />, // Replaces 🎓
    title: "Education",
    points: [
      "Share course news and updates",
      "Automate enrollment processes",
      "Send reminders for classes",
    ],
  },
  {
    icon: <FaShoppingCart />, // Replaces 🛍️
    title: "Retail",
    points: [
      "Promote new products and sales",
      "Send order confirmation alerts",
      "Notify about loyalty program updates",
    ],
  },
  {
    icon: <FaPlane />, // Replaces ✈️
    title: "Travel",
    points: [
      "Share flight and hotel deals",
      "Send itinerary reminders",
      "Notify about booking status",
    ],
  },
];

const extendedIndustries = [...industries, ...industries.slice(0, 4)];

export default function IndustriesSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselRef = useRef(null);
  const cardsToShow = 3; 

  const handleNext = () => {
    setCurrentIndex((prev) => {
      if (prev + 1 > industries.length - cardsToShow) {
        setTimeout(() => {
          carouselRef.current.style.transition = "none";
          setCurrentIndex(0);
          setTimeout(() => {
            carouselRef.current.style.transition = "transform 0.5s ease-in-out";
          }, 0);
        }, 500);
        return prev + 1;
      }
      return prev + 1;
    });
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => {
      if (prev === 0) {
        setTimeout(() => {
          carouselRef.current.style.transition = "none";
          setCurrentIndex(industries.length - cardsToShow + 1);
          setTimeout(() => {
            carouselRef.current.style.transition = "transform 0.5s ease-in-out";
          }, 0);
        }, 500); 
        return industries.length;
      }
      return prev - 1;
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.carousel}>
      <div
        ref={carouselRef}
        className={styles.container}
        style={{
          transform: `translateX(-${currentIndex * (15 + 1)}rem)`,
          transition: "transform 0.5s ease-in-out"
        }}
      >
        {extendedIndustries.map((industry, index) => (
          <div key={index} className={styles.card}>
            <div className={styles.icon}>{industry.icon}</div>
            <h3>{industry.title}</h3>
            <ul>
              {industry.points.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className={styles.buttons}>
        <button className={styles.prevButton} onClick={handlePrev}>
          ←
        </button>
        <button className={styles.nextButton} onClick={handleNext}>
          →
        </button>
      </div>
      <div className={styles.dots}>
        {industries.map((_, index) => (
          <span
            key={index}
            className={`${styles.dot} ${index === (currentIndex % industries.length) ? styles.activeDot : ""}`}
          ></span>
        ))}
      </div>
    </div>
  );
}